import React from "react";
import { SvgCss } from "../components/styles";

interface SvgGananciasProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

const SvgGanancias: React.FC<SvgGananciasProps> = ({
  className = "",
  width = 28,
  height = 28,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`${SvgCss.svgIcon} ${className}`}
  >
    {/* Tarjeta */}
    <rect x="2" y="5" width="20" height="14" rx="2" />

    {/* Banda superior */}
    <line x1="2" y1="9" x2="22" y2="9" />

    {/* Chip */}
    <rect x="5" y="12" width="3" height="2" rx="0.4" />

    {/* Líneas info */}
    <line x1="10" y1="13" x2="18" y2="13" />
    <line x1="10" y1="16" x2="15" y2="16" />
  </svg>
);


export default SvgGanancias;